import { RoleTypes } from "@/enums/role-types"
import { RolePlanner } from "@/models/role/role-planner.model"
import { RoleServiceProvider } from "@/models/role/role-service-provider.model"
import { RoleFinancialOfficer } from "@/models/role/role-financial-officer.model"

export function getSubclassForRoleType(type: RoleTypes) {
  const roleTypeToClassMap = {
    [RoleTypes.PLANNER]: RolePlanner,
    [RoleTypes.SERVICE_PROVIDER]: RoleServiceProvider,
    [RoleTypes.FINANCIAL_OFFICER]: RoleFinancialOfficer
  }

  if (!roleTypeToClassMap[type]) {
    throw new Error("No class found for role type")
  }
  return roleTypeToClassMap[type]
}

export function getRolesList(): RoleTypes[] {
  return Object.values(RoleTypes).filter((value): value is RoleTypes => typeof value === "number")
}
